import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import {
    autoTableCreationMetadata,
    disableMetricsCollectionCheckboxMetadata,
    getSqlParallelReadMetadataConsts,
    isolationLevelMetadata,
    maxConcurrentConnectionsMetadata,
    preCopyScriptMetadata,
    queryTimeoutMetadata,
    sqlWriteBatchSizeMetadata,
    sqlWriteBatchTimeoutMetadata,
    stringTimestampConversion
} from '../consts/metadata-consts';
import { ColumnType, defaultSupportedColumnTypes, sqlBinaryPhysicalTypes } from 'app/shared/utils/column-type.util';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { getSqlWriteBehavior } from '../consts/metadata-consts-with-ec-deps';
import {
    sqlServerBinaryLengthMap,
    sqlServerLogicalToPhysicalMapping,
    sqlServerPhysicalToLogicalMapping,
    sqlServerPrecisionMap,
    sqlServerScaleMap,
    sqlServerSupportedPhysicalTypes
} from './sqlserver-metadata';
import { UpdateMethod } from 'shell-models-lib';
import { getAppendOption, getSCD2Option, getUpsertOption } from 'app/registries/consts/copy-job-const';

export const azureSqlDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.azureSql.datasetType,
    supportLinkedServiceTypes: [adfModelTypeMap.azureSql.linkedServiceType],
    displayName: stringResources.AzureSql_DisplayText,
    datasetKind: 'table',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-100x100-AzureSQLDatabase'
    },
    supportAutoTableCreation: true,
    isFirstClass: true,
    supportGetMetadataActivity: true,
    isDataflowCompatible: true,
    supportDataFlowSink: true,
    supportDataFlowSource: true,
    supportDataFlowStoreProcedure: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    defaultSchema: 'dbo',
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Date),
    supportEditPhysicalType: __IS_FABRIC_DPE__,
    category: ['Azure'],
    supportParallelRead: true,
    copySourceControls: [queryTimeoutMetadata].concat([
        isolationLevelMetadata,
        getSqlParallelReadMetadataConsts(adfModelTypeMap.azureSql.copySourceType)
    ]),
    copySinkControls: [
        getSqlWriteBehavior(false),
        autoTableCreationMetadata(),
        preCopyScriptMetadata(),
        sqlWriteBatchTimeoutMetadata,
        sqlWriteBatchSizeMetadata,
        maxConcurrentConnectionsMetadata,
        disableMetricsCollectionCheckboxMetadata
    ],
    LogicalToPhysicalMapping: sqlServerLogicalToPhysicalMapping,
    PhysicalToLogicalMapping: sqlServerPhysicalToLogicalMapping,
    supportedPhysicalTypes: sqlServerSupportedPhysicalTypes,
    binaryPhysicalTypes: sqlBinaryPhysicalTypes,
    binaryLengthMap: sqlServerBinaryLengthMap,
    precisionMap: sqlServerPrecisionMap,
    scaleMap: sqlServerScaleMap,
    copySourcePropertiesRequireParameters: ['sqlReaderQuery', 'partitionOption'],
    copySinkPropertiesRequireParameters: ['preCopyScript', 'tableOption'],
    copyJob: {
        updateMethod: {
            supportUpdateMethod: true,
            options: [getAppendOption(), getUpsertOption(), getSCD2Option()],
            updateMethodProperties: ['writeBehavior', 'upsertSettings'],
            defaultUpdateMethod: UpdateMethod.Append,
            upsertKeyColumnRequired: true
        },
        fullLoadBehavior: {
            supportFullLoadBehavior: true
        },
        multipleQuery: true,
        incrementalColumnConversion: {
            supportConversion: true,
            conversionMapping: {
                ...stringTimestampConversion
            }
        },
        sourcePartition: {
            supportSourcePartition: true
        }
    }
};
